import theme from 'tailwindcss/defaultTheme';

export default Object.keys(theme.fontSize).reduce(
  (acc, key) => {
    const castedKey = key as keyof typeof theme.fontSize;
    const [rem, other] = theme.fontSize[castedKey];
    const fontSizeValue = rem.replace('rem', '');
    const lineHeightValue = other.lineHeight.replace('rem', '');

    acc[castedKey] = [`${parseFloat(fontSizeValue) * 16}px`, { lineHeight: `${parseFloat(lineHeightValue) * 16}px` }];
    return acc;
  },
  {} as Record<
    'xs' | 'sm' | 'base' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | '6xl' | '7xl' | '8xl' | '9xl',
    [string, { lineHeight: string }]
  >
);
